import React from 'react';
import {Box, ResponsiveContext, Text,} from 'grommet'

const style = {
    boxStyle: {
        borderRadius: '15px',
        textAlign: 'center',
        color: '#000000'
    }
}

function KeyBox({points, title, link}) {
    let background = "appBlue";
    const size = React.useContext(ResponsiveContext);
    if (size === "small" || size === "xsmall") background = "white";
    return (
        <Box className="customBox" style={style.boxStyle} pad="small" background={background}>
            {link ?
                <a href={link}><h2>{title}</h2></a>
                :
                <h2>{title}</h2>
            }
            <ul>
                {points.map( point => {
                    return(
                        <li>
                            {title === "Takeaways" || title === "Recommendations" ?
                                <Text>
                                    <span style={{fontWeight: 'bold'}}>{point.title} &nbsp;</span>
                                    {point.point}
                                </Text>
                                :
                                <Text>
                                    {point}
                                </Text>
                            }
                        </li>
                    )
                })}
            </ul>
        </Box>
    );
}

export default KeyBox